export const aanvraagVozdNl = {
  AanvraagVozdMijnZorggegevens: "Mijn zorggegevens",
  AanvraagVozdMijnGegevens: "Mijn gegevens"
};
